;(function () {
    function SidebarNavigation(dom) {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        /**
         * @type {element}
         */
        this.dom = dom

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            var navSub = this.dom.querySelectorAll('.js-nav-sub')

            navSub.forEach(function (element) {
                element.addEventListener('click', function (event) {
                    var currentElement = event.target
                    var parentLiElement = currentElement.parentElement.parentElement
                    var target = currentElement.parentElement.nextSibling

                    // Wrapper
                    if (!parentLiElement.classList.contains('sub-nav-expanded')) {
                        parentLiElement.classList.add('sub-nav-expanded')
                        parentLiElement.classList.remove('sub-nav-closed')
                    } else {
                        parentLiElement.classList.add('sub-nav-closed')
                        parentLiElement.classList.remove('sub-nav-expanded')
                    }

                    // Sub-Nav
                    if (!target.classList.contains('visible')) {
                        target.classList.add('visible')
                    } else {
                        target.classList.remove('visible')
                    }
                })
            })
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.Energy = window.Energy || {}
    window.Energy.SidebarNavigation = SidebarNavigation
})()

function initSidebarNavigation() {
    var sidebarNavigation = document.querySelector('.js-sidebar-navigation')
    if (sidebarNavigation) {
        new window.Energy.SidebarNavigation(sidebarNavigation)
    }
}

if (document.readyState !== 'loading') {
    initSidebarNavigation()
} else {
    document.addEventListener('DOMContentLoaded', function () {
        initSidebarNavigation()
    })
}
